import { Fragment } from "react";
import SpendingChartWithLegend from "../../charts/finances/SpendingChartWithLegend";
import StandardComparator from "../../comparators/StandardComparator";
import { getLanguageContent } from "../../../../utils/language/languageSelector";
import { PERSONAL_FINANCES_SCHEMA } from "../../../../utils/schemas/language/pages/personalFinancesSchema";

function StreamlineSpendingChart({
  data,
  title,
  growthCopy,
  unstyled = false,
}) {
  const content = getLanguageContent(PERSONAL_FINANCES_SCHEMA);
  if (!data) return null;

  const {
    currentTotal,
    previousTotalOnSameDay,
    spendingData,
    chartData,
    error,
  } = data;

  if (error) return <div className="error-msg">{error}</div>;

  return (
    <div className={`streamline-wrapper ${unstyled ? "unstyled" : ""}`}>
      <div className="streamline-header">
        <div className="col-layout bou-header-meta-desc income-header-row">
          <span className="income-label">
            {title || content.overview.money_flow.spending_trend}
          </span>
          <h2 className="income-amount margin-reset">
            ${currentTotal?.toLocaleString()}
          </h2>
        </div>
        <StandardComparator
          current={currentTotal}
          previous={previousTotalOnSameDay}
          comparisonLabel={spendingData?.previous_month_name}
          copy={growthCopy || content.overview.money_flow.growth}
        />
      </div>

      <div className="spending-breakdown-body">
        <SpendingChartWithLegend
          currentMonthData={chartData?.current_month}
          previousMonthData={chartData?.previous_month}
          averageData={chartData?.average_data}
          currentLabel={spendingData?.current_month_name}
          previousLabel={spendingData?.previous_month_name}
        />
      </div>
    </div>
  );
}

export default StreamlineSpendingChart;
